// Informações de versão injetadas em build time pelo Vite (vite.config.ts)
// Em ambientes onde as constantes não foram definidas (Vitest, etc.), usa fallback.

declare const __APP_VERSION__: string
declare const __GIT_COMMIT__: string
declare const __BUILD_DATE__: string

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'
export const GIT_COMMIT  = typeof __GIT_COMMIT__  !== 'undefined' ? __GIT_COMMIT__  : 'unknown'
export const BUILD_DATE  = typeof __BUILD_DATE__  !== 'undefined' ? __BUILD_DATE__  : new Date().toISOString()
